import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { Message } from "primeng/message";
import { Alert } from "./model/alert.model";
import { AlertStackService } from "./service/alert-stack.service";
import {
	combineLatest,
	distinctUntilChanged,
	filter,
	map,
	skip,
	startWith,
	Subject,
	takeUntil
} from "rxjs";
import { NavigationEnd, Router } from "@angular/router";

@Component({
	selector: "app-alert-stack",
	imports: [Message],
	templateUrl: "alert-stack.component.html",
	styles: ""
})
export class AlertStackComponent implements OnInit, OnDestroy {
	private readonly alertStackService = inject(AlertStackService);

	private readonly router = inject(Router);

	private readonly isDestroyed$ = new Subject<void>();

	alerts: Alert[] = [];

	ngOnInit() {
		const currentRoute$ = this.router.events.pipe(
			filter((event): event is NavigationEnd => event instanceof NavigationEnd),
			map(event => event.urlAfterRedirects),
			startWith(this.router.url),
			distinctUntilChanged()
		);

		currentRoute$
			.pipe(skip(1), takeUntil(this.isDestroyed$))
			.subscribe({ next: () => this.alertStackService.clearAlerts() });

		combineLatest([this.alertStackService.alerts$, currentRoute$])
			.pipe(
				map(([alerts, currentRoute]) =>
					alerts.filter(alert => currentRoute.includes(`/${alert.page}`))
				),
				takeUntil(this.isDestroyed$)
			)
			.subscribe({
				next: alerts => (this.alerts = alerts)
			});
	}

	ngOnDestroy() {
		this.isDestroyed$.next();
		this.isDestroyed$.complete();
	}

	onAlertRemove(alert: Alert) {
		this.alertStackService.removeAlert(alert);
	}
}
